var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lowerthird"},[_c('div',{class:_vm.text_container_style_name},[_c('h1',[_vm._v(_vm._s(_vm.name))]),(_vm.title.length > 0)?_c('h2',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"background"})])])}
var staticRenderFns = []

export { render, staticRenderFns }